import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalProvider } from './common/contexts/GlobalContext';
import { AuthProvider } from './features/auth/contexts/AuthContext';
import AppLayout from './common/components/AppLayout';
import PublicMapLayout from './common/components/PublicMapLayout';

function App() {
  return (
    <AuthProvider>
      <GlobalProvider>
        <Router>
          <Routes>
            {/* Public route - no authentication required */}
            <Route path="/public-map/*" element={<PublicMapLayout />} />
            
            {/* Protected routes - require authentication */}
            {/* Use exact for root to prevent double rendering */}
            <Route path="/" element={<Navigate to="/admin/map" replace />} />
            <Route path="/admin" element={<Navigate to="/admin/map" replace />} />
            <Route path="/admin/*" element={<AppLayout />} />
            <Route path="/login" element={<AppLayout />} />
          </Routes>
        </Router>
      </GlobalProvider>
    </AuthProvider>
  );
}

export default App;
